import * as keyapis_encryption_profile_v1_encryption_profile_pb from "./v1/keyapis_encryption_profile_encryption_profile_v1.pb";
import * as keyapis_encryption_profile_v1_system_pb from "./v1/keyapis_encryption_profile_system_v1.pb";

export default {
  v1: {
    resources: {
      encryptionProfile: keyapis_encryption_profile_v1_encryption_profile_pb,
      system: keyapis_encryption_profile_v1_system_pb,
    },
  },
};
